<script setup lang="ts">
const props = defineProps<{
  post?: PostItem | null;
}>();

const tags = computed(
  () =>
    props.post?.tags?.reduce<TagItem[]>((acc, tag) => {
      if (tag.tags_id) acc.push(tag.tags_id);
      return acc;
    }, []) || []
);
</script>

<template>
  <section class="post-tags">
    <div class="post-tags__container container">
      <div class="post-tags__wrapper">
        <div class="post-tags__title sr-only">
          <h2
            class="text-[2.5rem] leading-[2.5rem] lg:text-[3.125rem] lg:leading-[2.75rem]"
          >
            <span class="inline">Słowa</span>
            <span class="inline tracking-[0.25rem]">&emsp14;</span>
            <span class="inline font-display tracking-[0.3125rem]"
              >kluczowe</span
            >
          </h2>
        </div>

        <div class="post-tags__content">
          <ul
            class="post-tags__items flex items-center justify-start gap-4 flex-wrap"
          >
            <li
              class="post-tags__item min-w-0 max-w-full bg-[#F8F8F8] text-[#242020] h-10 px-4 flex items-center justify-center text-center rounded-e-[0.875rem] rounded-b-[0.875rem] select-none"
              v-for="item in tags"
            >
              <div
                class="post-tags__item-wrapper min-w-0 max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {{ item.title }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
